//$Id$
/**
 * @file i18n-util
 * @version 1.0.0
 * @notes Deprecated Functions: getBugI18nValue, getBugi18nValues, getBugRepValue, getFormsI18nValue, getMileRepValue - Use getI18nValueWithParam
 */

/**
 * Get localized message for the specified I18N string
 * @param {string} key I18N key
 * @returns {string} localized message
 */
function getI18nValue(key)
{
	return getI18nValueWithParam(key, []);
}

/**
 * Replace the placeholder with given values  and returns localized message.
 * @param {string} key I18N key
 * @param {*} jArrVal placeholder values 
 * @returns {string} localized message  
 */
function getI18nValueWithParam(key,jArrVal){
    let obj = clientJSON[key];
    if(obj===null || obj===undefined)
    {
	return key;
    }
    else if (Utils.isVcrmPartnerOrClient && !Utils.isBundledPortal){
		if(vcrmsupportMailId != ""){obj=obj.replace(new RegExp(Utils.support_email,"gi"),vcrmsupportMailId);}
		if(vcrmappName != ""){
	   	    obj=obj.replace(/Zoho Projects/gi,vcrmappName);
			obj=obj.replace(/zoho/gi,vcrmappName);
			obj=obj.replace(/Zoho/gi,vcrmappName);
		}
	}
     let index=0;
     for(const element of jArrVal){
         obj = obj.replace("{"+index+"}" , element);
         index++;
     }
    return obj;
}
function getModuleRenameValue(module,key,type)
{
	let i18nvalue ;
	switch(module){
		case 'issues': //no i18n
			i18nvalue = 'plural' == type ? Utils.bugPluralValue : Utils.bugReplaceValue; //no i18n
			break;
		case 'phases': //no i18n
			i18nvalue = 'plural' == type ? Utils.milestonePluralValue : Utils.milestoneSingularValue; //no i18n
			break;
		case 'tasks': //no i18n
			i18nvalue = 'plural' == type ? Utils.taskPluralValue : Utils.taskSingularValue; //no i18n
			break;
		case 'projects': //no i18n
			i18nvalue = getI18nValue('zp.home.project'); //no i18n
			break;
		default:
			i18nvalue = module;
			break;
	}
	return getI18nValueWithParam(key,[i18nvalue]);
}

Object.assign(window, {getI18nValue, getI18nValueWithParam, getModuleRenameValue});